/**
 * Amada collection promise — hours until midnight Europe/London + delivery date (+10 days).
 * Enhances [data-amada-promise]; Liquid seeds static fallbacks for SEO/noscript.
 */
(function () {
  const TZ = 'Europe/London';
  const DELIVERY_DAYS = 10;

  function londonParts(date) {
    const map = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(date)
      .forEach((p) => {
        if (p.type !== 'literal') map[p.type] = p.value;
      });
    return {
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day),
      hour: Number(map.hour),
      minute: Number(map.minute),
      second: Number(map.second),
    };
  }

  function cutoffLabel(now) {
    const p = londonParts(now);
    let secs = 24 * 3600 - (p.hour * 3600 + p.minute * 60 + p.second);
    if (secs <= 0) secs = 24 * 3600;
    const mins = Math.round(secs / 60);
    if (mins < 60) return mins <= 1 ? '1 minute' : mins + ' minutes';
    const hours = Math.max(1, Math.round(mins / 60));
    return hours === 1 ? '1 hour' : hours + ' hours';
  }

  function deliveryLabel(now) {
    const p = londonParts(now);
    const target = new Date(Date.UTC(p.year, p.month - 1, p.day + DELIVERY_DAYS));
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    }).format(target);
  }

  function paint(root) {
    const cutoffEl = root.querySelector('[data-amada-promise-cutoff]');
    const dateEl = root.querySelector('[data-amada-promise-date]');
    const now = new Date();
    if (cutoffEl) cutoffEl.textContent = cutoffLabel(now);
    if (dateEl) dateEl.textContent = deliveryLabel(now);
  }

  function init() {
    document.querySelectorAll('[data-amada-promise]').forEach(paint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
